import { PortfolioTransferComponent } from './pages/portfolio-transfer/portfolio-transfer.component';

export const DEPOT_TRANSFER_WEB_ROUTES = [
  {
    path: '',
    component: PortfolioTransferComponent,
  },
];
